/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
/* eslint-disable prefer-const */
/* eslint-disable eqeqeq */
/* eslint-disable no-var */
/* eslint-disable vars-on-top */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable-next-line dot-notation */
/* eslint-disable dot-notation */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { styled, useTheme } from "@mui/material/styles";
import PropTypes from 'prop-types';
// eslint-disable-next-line import/order
import { usePopupManager } from "./providers/PopupManager/PopupManager";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ReviewsIcon from '@mui/icons-material/Reviews';
import Collapse from "@mui/material/Collapse";
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import HomeIcon from "@mui/icons-material/Home";
import AccessibilityIcon from "@material-ui/icons/Accessibility";
import SummarizeIcon from '@mui/icons-material/Summarize';
import Help from './assets/images/person.png'
import { setLogin } from "./redux/features/auth/actions";
import Truckloading from "./components/CvLoader/Cvloader";
import {
  DATE_FORMAT,
  API_RESOURCE_URLS,
  DISPLAY_MESSAGES,
  MESSAGE_TYPE,
  RESOURCE_TYPE,
  USER_OPERATIONS,
  Regex,
} from "./constants";
import apiService from "./apis/apiService";

const drawerWidth = 250;
const drawerWidthMObile = 200;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

function MiniDrawer({ displayDrawer, openClose, auth, baseUrl }) {

  const { userRole } = auth;
  let ipAddress2=false;

 ipAddress2=auth?.ip_address?.startsWith("intranet") 

  const wd = displayDrawer == "mobile" ? drawerWidthMObile : drawerWidth;

  const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== "open",
  })(({ theme, open }) => ({
    width: wd,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    ...(open && {
      ...openedMixin(theme),
      "& .MuiDrawer-paper": openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      "& .MuiDrawer-paper": closedMixin(theme),
    }),
  }));

  const myStyles = {
    margin: "0.1em",
    marginLeft: "0.2em",
    fontSize: "11px",
    fontWeight: "bold",
    textAlign: "left",
    letterSpacing: "0em",
    color: "#4e4e4e",
    opacity: 1,
  };
  const ssx = {
    fontSize: "12px",
    marginLeft: "0.1em",
    fontWeight: "bold",
    textAlign: "left",
    letterSpacing: "0em",
    color: "#4e4e4e",
    opacity: 1,
  };
  const ssx2 = {
    fontSize: "14px",
    marginLeft: "1.0em",
    fontWeight: "bold",
    textAlign: "left",
    letterSpacing: "0em",
    color: "#4e4e4e",
    opacity: 1,
  };
  const mobStyle2 = {
    fontSize: "11px !important",
    marginLeft: "1.0em",
    fontWeight: "bold",
    textAlign: "left",
    letterSpacing: "0em",
    color: "#4e4e4e",
    opacity: 1,
  };
  const mobStyle = {
    fontSize: "10px !important",
    marginLeft: "0.1em",
    fontWeight: "bold",
    textAlign: "left",
    letterSpacing: "0em",
    color: "#4e4e4e",
    opacity: 1,
  };
  const theme = useTheme();
  const [open, setOpen] = useState(openClose);
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [openLinkage, setOpenLinkage] = useState(false);
  const [openAccess, setOpenAccess] = useState(false);
  const [openTimeBook, setOpenTimeBook] = useState(false);
  const [report, setReport] = useState(false);
  const [menuDetails, setMenuDetails] = useState([]);
  const [submenuLinks, setSubmenuLinks] = useState([]);
  const [loading, setLoading] = useState(false);

  const { showPopup } = usePopupManager();
  const dispatchNew= useDispatch();
  const handleClick = () => {
    setOpen1(!open1);
  };
  const handleClickTime = () => {
    setOpen3(!open3);
  };
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleClickLinkage = () => {
    setOpenLinkage(!openLinkage);
  };

  const handleClickTimeBooking = () => {
    setOpenTimeBook(!openTimeBook);
  };

  const handleAccessControl = () => {
    setOpenAccess(!openAccess);
    dispatchNew(setLogin({ ...auth, apiSendData: undefined}));
  };

  const handleMobileAccesss = () => {
    setOpen2(!open2);
  };

  const handleMobileTime=()=>{
    setOpen4(!open4)
  }

  const handleReport=()=>{
    setReport(!report)
  }

  const getMenuDetails = async() =>{

    setLoading(true)

      let networkFlag = "";
      if(ipAddress2){
        networkFlag = "N";
      }
      else{
        networkFlag = "Y";
      }
      let apiFormatedData = {
        pers_no: auth.personNumber,
        co_code: auth.companyCode,
        internet_enabled:networkFlag
      }
    try {
      const response = await apiService.getMenuList(apiFormatedData, dispatchNew)
      if(response.msg === "Success"){
        setLoading(false);
        setMenuDetails(response.data);
       
      }
    
    } catch (error) {
      setLoading(false)
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: error.response.message || " Failed to fetch the menu",
      });
    }
    }

   useEffect(() => {
    if(auth.personNumber){
      getMenuDetails();
    }      
  },[auth.personNumber])

  useEffect(() => {
    const links = [];
    menuDetails.forEach(menuItem => {
        menuItem.submenu_items.forEach(submenuItem => {       
        links.push({
          component: `${submenuItem.component}`,
          url: `${submenuItem.submenu_link}`,
          label : `${submenuItem.submenu_name}`,
        });
 
      });

      if(menuItem.menu_id === 'PL'){
        links.push(
          { 
            component: 'BulkSpocForm',
            url:'/bulk-spoc-uploaddel/:parameter',
            label:'Bulk Linkage / De-linkage'
          },
          {
            component: 'BulkSpocForm',
            url:'/bulk-spoc-uploaddel/:parameter',
            label:'Bulk SPOC aceess'
          },
        );
      }
      if(menuItem.menu_id === 'AM'){
        links.push(
          { 
            component: 'AccessControl',
            url:'/access-control/:requestType/:activeId',
            label:'Access Control'
          },
          {
            component: 'RequestView',
            url:'/request-view/:requestType/:activeId',
            label:'Request View'
          },
        );
        
        if (userRole.includes("B")){
          links.push(
            { 
              component: 'AccessControl',
              url:'/access-control/APL',
              label:'Additional Project Linkage'
            },
            {
              component: 'LinkageDashboard',
              url:'/linkage-dashboard',
              label:'Linkage Dashboard',
            },
          )
        }
      }

    });

    setSubmenuLinks(links);
    dispatchNew(setLogin({...auth, menuList: links}));
    
    // menuURLs(links);
    // setSubmenuLinks(links.filter(link => link)); // Filter out empty strings
  }, [menuDetails]);

  const handleDrawerClose = () => {
    setOpen(false);
    setOpen1(false);
    setOpenLinkage(false);
    setOpenAccess(false);
    setOpenTimeBook(false);
    setOpen4(false);
    setReport(false)
  };
  var displayFlag = openClose ? "block" : "none";

  return (
    <>
    {loading ? 
      (
        <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"40px"}}>
           <Truckloading />
        </div> 
      ) : 
      <div>
      {displayDrawer == "mobile" ? (
              <Drawer
              variant="permanent"
              open={open}
              onMouseEnter={handleDrawerOpen}
              onClose={handleDrawerClose}
              onMouseLeave={handleDrawerClose}
              onBlur={handleDrawerClose}
              PaperProps={{
                      sx: {
                        height: "90%",
                        width: "40%",
                        top: 52,
                        marginBottom: "40px",
                      },
                    }}
                    style={{ display: displayFlag }}
                    sx={{
                      display: { xs: "block", sm: "none" },
                      "& .MuiDrawer-paper": {
                        boxSizing: "border-box",
                        width: wd,
                      },
                   }}
            >
              <List>
              {menuDetails.map((item, index) => (     
                <div key={item.program_id}>
                  {["H", "TBR", "X"].includes(item.menu_id) ? (
                    <>
                    <Divider />
                    {item.submenu_items.length >= 1 ? (  
                    <ListItem
                    disablePadding
                    sx={{ display: "block" }}
                    component={Link}
                    to={item.submenu_items[0].submenu_link}
                  >
                    <ListItemButton
                      sx={{
                        minHeight: 48,
                        // justifyContent: open ? "initial" : "center",
                        justifyContent: "center",
                        px: 2.5,
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          // mr: open ? 3 : "auto",
                          justifyContent: "center",
                        }}
                      >
                        {
                          item.menu_id === 'H' ? <HomeIcon style={{ color: "#2162ac", height:"20px", width:"20px" }} /> : 
                          item.menu_id === 'X' ? <img src={Help} style={{height:"20px", width:"20px"}} alt="test" /> : item.menu_id === 'TBR' ? <ReviewsIcon style={{ color: "#2162ac", height:"20px", width:"20px" }} /> : 
                          ''
                        }
                      </ListItemIcon>
                      {/* <p>{item.menu_desc}</p> */}
                      <ListItemText
                        primary={item.menu_desc}
                        sx={{ opacity: 1}}
                        primaryTypographyProps={mobStyle2}
                      />
                    </ListItemButton>
                    </ListItem>) : ''}
                     </>
                  ) : (
      
                    <>
                    {item.submenu_items.length >= 1 ? <Divider /> : <></>}
                    {item.submenu_items.length >= 1 ?
                    <>
                        <ListItem disablePadding sx={{ display:"block"}}>
                          <ListItemButton
                            sx={{
                              minHeight: 48,
                              justifyContent:"initial",
                              px: 2.5,
                            }}
                            // onClick={handleClickTimeBooking}
                            onClick={
                              item.menu_id === 'T' ? handleClickTimeBooking : 
                              item.menu_id === 'PL' ? handleClickLinkage :
                              item.menu_id === 'AM' ? handleAccessControl :
                              item.menu_id === 'R' ? handleMobileTime :
                              "" 
                              }
                          >
                            <ListItemIcon
                              sx={{
                                minWidth: 0,
                                // mr: open ? 3 : "auto",
                                justifyContent: "center",
                              }}
                            >
                            {item.menu_id === "T" ? (
                            <CalendarMonthIcon style={{ color: "#2162ac" }} onClick={() => setOpenTimeBook(true)} />
                            ) : item.menu_id === "PL" ? (
                              <AccessibilityIcon style={{ color: "#2162ac" }} onClick={() => setOpenLinkage(true)} />
                            ) : item.menu_id === "AM" ? (
                              <PendingActionsIcon style={{ color: "#2162ac" }} onClick={() => setOpenAccess(true)} />
                            ) : item.menu_id === "R" ? (
                              <SummarizeIcon style={{ color: "#2162ac" }} onClick={() => setOpen4(true)} />
                            ) : null}
                            </ListItemIcon>
                            <ListItemText
                              primary={item.menu_desc}
                              sx={{ opacity: 1}}
                              primaryTypographyProps={mobStyle2}
                            />
                          </ListItemButton>
                        </ListItem>
                        <Collapse in= {
                            item.menu_id === 'T' ? openTimeBook : 
                            item.menu_id === 'PL' ? openLinkage : 
                            item.menu_id === 'AM' ? openAccess : 
                            item.menu_id === 'R' ? open4 : ''}
                            timeout="auto" 
                            unmountOnExit
                        >
                        <List component="div" disablePadding>
                        {item.submenu_items.map((submenu) => (
                          // <ListItem disablePadding sx={{ display:"block"}}>
                          // <ListItemButton
                          // sx={{
                          //   minHeight: 40,
                          //   justifyContent:"initial",
                          //   px: 2.5,
                          // }}
                          // component={Link}
                          // to={submenu.submenu_link}
                          // >
                          <ListItem
                            key={submenu.submenu_id}
                            disablePadding
                            sx={{
                                minHeight: 40,
                                justifyContent:"initial",
                                px: 2.5,
                              }}
                              component={Link}
                              to={submenu.submenu_link}
                              onClick={handleDrawerClose}
                          >
                          <ListItemButton
                            sx={{
                              minHeight: 40,
                              justifyContent: "initial",
                              px: 2.5,
                            }}
                            
                          >
                          <ListItemIcon sx={{ minWidth: { xs: "29px", lg: "53px",  md:"53px"}}}>
                          <KeyboardArrowRightRoundedIcon />
                          </ListItemIcon>
                            <ListItemText
                            primary={submenu.submenu_name}
                            primaryTypographyProps={mobStyle}
                            />
                          </ListItemButton>
                          </ListItem>
                        ))}
                        </List>
                        </Collapse>
                    </>
                      : ''}
                    </>
                    
                  )}
                </div>
                ))}
              </List>
              </Drawer>
      //  <Drawer
      //     variant="permanent"
      //     open={openClose}
      //     // open={open}
      //     onMouseEnter={handleDrawerOpen}
      //     onMouseLeave={handleDrawerClose}
      //     PaperProps={{
      //       sx: {
      //         height: "90%",
      //         width: "40%",
      //         top: 52,
      //         marginBottom: "40px",
      //       },
      //     }}
      //     style={{ display: displayFlag }}
      //     sx={{
      //       display: { xs: "block", sm: "none" },
      //       "& .MuiDrawer-paper": {
      //         boxSizing: "border-box",
      //         width: wd,
      //       },
      //     }}
      //   >
      //   <List>
      //   {menuDetails.map((item, index) => (
      //     <div key={item.program_id}>
      //       {item.menu_id === 'H' || item.menu_id === 'X' ? (
      //         <>
      //         <ListItem
      //         disablePadding
      //         sx={{ display: "block" }}
      //         component={Link}
      //         to={item.submenu_items[0].submenu_link}
      //       >
      //         <ListItemButton
      //           sx={{
      //             minHeight: 48,
      //             justifyContent: open ? "initial" : "center",
      //             px: 2.5,
      //           }}
      //         >
      //           <ListItemIcon
      //             sx={{
      //               minWidth: 0,
      //               mr: open ? 3 : "auto",
      //               justifyContent: "center",
      //             }}
      //           >
      //             <HomeIcon style={{ color: "#2162ac" }} />
      //           </ListItemIcon>
      //           <ListItemText
      //             primary={item.menu_desc}
      //             sx={{ opacity: open ? 1 : 0 }}
      //             primaryTypographyProps={ssx2}
      //           />
      //         </ListItemButton>
      //         </ListItem>
      //          <Divider />
      //          </>
      //       ): (
      //         <>
      //         <Divider />
      //         <ListItem disablePadding sx={{ display:"block"}}>
                    
      //           <ListItemButton
      //             sx={{
      //               minHeight: 48,
      //               justifyContent: open ? "initial" : "center",
      //               px: 2.5,
      //             }}
      //             // onClick={handleClickTimeBooking}
      //             onClick={
      //               item.menu_id === 'T' ? handleClickTimeBooking : 
      //               item.menu_id === 'PL' ? handleClickLinkage :
      //               item.menu_id === 'AM' ? handleAccessControl :
      //               item.menu_id === 'R' ? handleMobileTime :
      //                "" 
      //               }
      //           >
      //             <ListItemIcon
      //               sx={{
      //                 minWidth: 0,
      //                 mr: open ? 3 : "auto",
      //                 justifyContent: "center",
      //               }}
      //             >
      //               {/* <CalendarMonthIcon
      //                 style={{ color: "#2162ac" }}
      //                 onClick={() => setOpenTimeBook(true)}
      //               /> */}
      //             {
      //             item.menu_id === 'T' ? <CalendarMonthIcon style={{ color: "#2162ac" }} onClick={() => setOpenTimeBook(true)}/> : 
      //             item.menu_id === 'PL' ? <AccessibilityIcon style={{ color: "#2162ac" }} onClick={() => setOpenLinkage(true)} /> : 
      //             item.menu_id === 'AM' ? <PendingActionsIcon style={{ color: "#2162ac" }} onClick={() => setOpenAccess(true)} /> : 
      //             item.menu_id === 'R' ? <SummarizeIcon style={{ color: "#2162ac" }} onClick={() => {
      //             setOpen4(true)}} /> : 
      //             item.menu_id === 'X' ? <img src={Help} style={{height:"23px",width:"23px"}} alt="test" /> 
      //             : ''
      //             }
      //             </ListItemIcon>
      //             <ListItemText
      //               primary={item.menu_desc}
      //               sx={{ opacity: open ? 1 : 0 }}
      //               primaryTypographyProps={ssx2}
      //             />
      //           </ListItemButton>
                
      //               <Collapse in= {
      //                   item.menu_id === 'T' ? openTimeBook : 
      //                   item.menu_id === 'PL' ? openLinkage : 
      //                   item.menu_id === 'AM' ? openAccess : 
      //                   item.menu_id === 'R' ? open4 : ''}
      //                   timeout="auto" 
      //                   unmountOnExit
      //               >
      //             <List component="div" disablePadding>
      //             {item.submenu_items.map((submenu) => (
      //               <ListItemButton
      //               sx={{
      //                 minHeight: 40,
      //                 justifyContent: open ? "initial" : "center",
      //                 px: 1.5,
      //               }}
      //               component={Link}
      //               to={submenu.submenu_link}
      //               >
      //               <ListItemIcon sx={{ minWidth: { xs: "29px", lg: "53px",  md:"53px"}}}>
      //               <KeyboardArrowRightRoundedIcon />
      //               </ListItemIcon>
      //                 <ListItemText
      //                 primary={submenu.submenu_name}
      //                 primaryTypographyProps={ssx}
      //                 />
      //               </ListItemButton>
      //             ))}
      //             </List>
      //           </Collapse>
      //         </ListItem>
      //         </>
      //       )}
      //     </div>
      //     ))}
      //   </List>
      //   </Drawer>
      ) : (
        <Drawer
        variant="permanent"
        open={open}
        onMouseEnter={handleDrawerOpen}
        onClose={handleDrawerClose}
        onMouseLeave={handleDrawerClose}
        onBlur={handleDrawerClose}
        PaperProps={{
          sx: {
            height: "90%",
            top: 52,
            marginBottom: "35px",
          },
        }}
      >
        <List>
        {menuDetails.map((item, index) => (     
          <div key={item.program_id}>

            {item.menu_id === 'H' || item.menu_id === 'X' || item.menu_id === 'TBR' ? (
              <>
              {/* <div>test1: {item.submenu_items.length}</div> */}
              {/* <div>{setMenuURLs(item.submenu_items[1]["submenu_link"])}</div> */}
              <Divider />
              {item.submenu_items.length >= 1 ? (  
              <ListItem
              disablePadding
              sx={{ display: "block" }}
              component={Link}
              to={item.submenu_items[0].submenu_link}
              // to='/home'
            >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  {
                    item.menu_id === 'H' ? <HomeIcon style={{ color: "#2162ac" }} /> : 
                    item.menu_id === 'X' ? <img src={Help} style={{height:"23px", width:"23px"}} alt="test" /> : item.menu_id === 'TBR' ? <ReviewsIcon style={{ color: "#2162ac" }} /> : 
                    ''
                  }
                </ListItemIcon>
                <ListItemText
                  primary={item.menu_desc}
                  sx={{ opacity: open ? 1 : 0 }}
                  primaryTypographyProps={ssx2}
                />
              </ListItemButton>
              </ListItem>) : ''}
               </>
            ) : (

              <>
              {item.submenu_items.length >= 1 ? <Divider /> : <></>}
              {item.submenu_items.length >= 1 ?
              <ListItem disablePadding sx={{ display:"block"}}>
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                  // onClick={handleClickTimeBooking}
                  onClick={
                    item.menu_id === 'T' ? handleClickTimeBooking : 
                    item.menu_id === 'PL' ? handleClickLinkage :
                    item.menu_id === 'AM' ? handleAccessControl :
                    item.menu_id === 'R' ? handleMobileTime :
                     "" 
                    }
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                  {
                  item.menu_id === 'T' ? <CalendarMonthIcon style={{ color: "#2162ac" }} onClick={() => setOpenTimeBook(true)}/> : 
                  item.menu_id === 'PL' ? <AccessibilityIcon style={{ color: "#2162ac" }} onClick={() => setOpenLinkage(true)} /> : 
                  item.menu_id === 'AM' ? <PendingActionsIcon style={{ color: "#2162ac" }} onClick={() => setOpenAccess(true)} /> : 
                  item.menu_id === 'R' ? <SummarizeIcon style={{ color: "#2162ac" }} onClick={() => {
                  setOpen4(true)}} /> : ''
                  }
                  </ListItemIcon>
                  <ListItemText
                    primary={item.menu_desc}
                    sx={{ opacity: open ? 1 : 0 }}
                    primaryTypographyProps={ssx2}
                  />
                </ListItemButton>
                
                    <Collapse in= {
                        item.menu_id === 'T' ? openTimeBook : 
                        item.menu_id === 'PL' ? openLinkage : 
                        item.menu_id === 'AM' ? openAccess : 
                        item.menu_id === 'R' ? open4 : ''}
                        timeout="auto" 
                        unmountOnExit
                    >
                  <List component="div" disablePadding>
                  {item.submenu_items.map((submenu) => (
                    <ListItemButton
                    sx={{
                      minHeight: 40,
                      justifyContent: open ? "initial" : "center",
                      px: 1.5,
                    }}
                    component={Link}
                    to={submenu.submenu_link}
                    >
                    <ListItemIcon sx={{ minWidth: { xs: "29px", lg: "53px",  md:"53px"}}}>
                    <KeyboardArrowRightRoundedIcon />
                    </ListItemIcon>
                      <ListItemText
                      primary={submenu.submenu_name}
                      primaryTypographyProps={ssx}
                      />
                    </ListItemButton>
                  ))}
                  </List>
                </Collapse>
              </ListItem>
                : ''}
              </>
              
            )}
          </div>
          ))}
        </List>
        </Drawer>
      )}
    </div>
    }
    </>
  );
}

const mapStateToProps = (state) => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth
});

export default connect(mapStateToProps)(MiniDrawer);